import {
  TRAINER_INVITATION_STATUS,
  TRAINER_INVITATION_STATUS_STRINGS
} from '../data/trainer-invitation-status.constants';

export const getStatusString = (status: number): string => {
  switch (status) {
    case TRAINER_INVITATION_STATUS.PENDING:
      return TRAINER_INVITATION_STATUS_STRINGS.PENDING;
    case TRAINER_INVITATION_STATUS.ACCEPTED:
      return TRAINER_INVITATION_STATUS_STRINGS.ACCEPTED;
    case TRAINER_INVITATION_STATUS.EXPIRED:
      return TRAINER_INVITATION_STATUS_STRINGS.EXPIRED;
    case TRAINER_INVITATION_STATUS.CANCELLED:
      return TRAINER_INVITATION_STATUS_STRINGS.CANCELLED;
    case TRAINER_INVITATION_STATUS.REJECTED:
      return TRAINER_INVITATION_STATUS_STRINGS.REJECTED;
    default:
      return TRAINER_INVITATION_STATUS_STRINGS.PENDING;
  }
};

export const getStatusColor = (status: number): 'default' | 'warning' | 'success' | 'error' => {
  switch (status) {
    case TRAINER_INVITATION_STATUS.PENDING:
      return 'warning';
    case TRAINER_INVITATION_STATUS.ACCEPTED:
      return 'success';
    case TRAINER_INVITATION_STATUS.EXPIRED:
      return 'error';
    case TRAINER_INVITATION_STATUS.CANCELLED:
      return 'default';
    case TRAINER_INVITATION_STATUS.REJECTED:
      return 'default';
    default:
      return 'default';
  }
};
